import { render } from "./PanelTemplate.vue?vue&type=template&id=75fde6cf&ts=true"
import script from "./PanelTemplate.vue?vue&type=script&lang=ts"
export * from "./PanelTemplate.vue?vue&type=script&lang=ts"

import "./PanelTemplate.vue?vue&type=style&index=0&id=75fde6cf&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__